import isNil from 'lodash/isNil';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classnames from 'classnames';

import { IntersectionDetector } from 'zoomforth_zfutils/viewport_intersection_utils.js';

import Image from 'zoomforth_codesbane_viewer/component_lib/image.jsx';
import { zfImagePropType } from 'zoomforth_codesbane_viewer/lib/prop_types.js';
import {
  animationClassGenerator,
  ConditionalWrapper,
} from 'zoomforth_page_version_viewer/utils.js';

function isCropped(needsCrop, zfImage) {
  if (zfImage) {
    return !!zfImage.cropData;
  }

  return !needsCrop;
}

const autocropImage = ($tileImg) => {
  // this is a little hacky: we need to depend on a node that lives in the parent context.
  // I think this is better than the alternative of making this function live in that context --
  // and since this is such a specific system,
  // we CAN depend on $('.tile-padding-wrapper') being a parent of this component
  const $tilePaddingWrapper = $tileImg.closest('.tile-padding-wrapper');
  const $inMemoryImage = $('<img/>')
    .one('load', function () {
      var imgRatio = (this.width * 1.0) / this.height;
      var containingHeight;
      // in mobile, captions can be pushed underneath -- so the container
      // we want to fit in is div.tile then, as opposed to div.tile-padding-wrapper.
      // the widths are the same for both, so only height needs to be adjusted
      if ($tilePaddingWrapper.hasClass('push-caption-underneath')) {
        containingHeight = $tilePaddingWrapper.find('.tile').height();
      } else {
        containingHeight = $tilePaddingWrapper.height();
      }
      var wrapperRatio = ($tilePaddingWrapper.width() * 1.0) / containingHeight;
      if (imgRatio > wrapperRatio) {
        $tileImg.css({
          width: imgRatio * containingHeight,
          height: '100%',
        });
      } else {
        $tileImg.css({
          width: '100%',
          height: (1 / imgRatio) * $tilePaddingWrapper.width(),
        });
      }
    })
    .attr('src', $tileImg.attr('src'));

  if ($inMemoryImage.get(0).complete) {
    $inMemoryImage.load();
  } //ie fix, sometimes it aborts the in-memory load if it is cached.
};

const resetCrop = ($tileImg) => {
  $tileImg.css({
    width: '100%',
    height: '100%',
  });
};

class GridTileInnerTypeImage extends Component {
  constructor(props) {
    super(props);
    this.tileImageNodeRef = null;
    this.state = {
      visibility: false,
    };
  }

  componentDidMount() {
    this.doPostRender();
  }

  componentDidUpdate(prevProps) {
    // If the image was previously cropped but is no longer cropped, we need to
    // reset the height and width so it stays proportionally correct. For
    // example, when changing the display image in the editor.
    if (prevProps.needsCrop === true && this.props.needsCrop === false) {
      const $tileImageNode = $(this.tileImageNodeRef);
      resetCrop($tileImageNode);
    } else {
      this.doPostRender();
    }
  }

  doPostRender() {
    // would be nice to refactor needs_crop to work differently. maybe can be replaced with a classname?
    // -- look up all custom css. if needs_crop is not used, we can change all our references to use a classname instead.
    if (this.tileImageNodeRef && this.props.needsCrop) {
      const $tileImageNode = $(this.tileImageNodeRef);
      window.setTimeout(() => {
        autocropImage($tileImageNode);
      }, 0);
    }
  }

  render() {
    let animationClasses;
    let animationRunsOnce = true;

    if (this.props.animationSettings) {
      const { animationType, animationSpeed, animationRepeats } =
        this.props.animationSettings;
      animationClasses = animationClassGenerator(animationType, animationSpeed);
      if (!isNil(animationRepeats)) {
        animationRunsOnce = !animationRepeats;
      }
    }

    return (
      <ConditionalWrapper
        condition={!isNil(this.props.animationSettings)}
        wrapper={(children) => (
          <IntersectionDetector
            animationClasses={animationClasses}
            triggerOnce={animationRunsOnce}
          >
            {children}
          </IntersectionDetector>
        )}
      >
        <div className='tile-image-wrapper'>
          <Image
            zfImage={this.props.zfImage}
            className={classnames(
              'tile-image',
              isCropped(this.props.needsCrop, this.props.zfImage)
                ? 'is-cropped'
                : 'is-not-cropped'
            )}
            refFunc={(ref) => {
              this.tileImageNodeRef = ref;
            }}
            src={this.props.imageSrc}
            altText={this.props.altText}
            draggable='false'
          />
        </div>
      </ConditionalWrapper>
    );
  }
}

GridTileInnerTypeImage.propTypes = {
  zfImage: zfImagePropType,
  imageSrc: PropTypes.string,
  altText: PropTypes.string,
  needsCrop: PropTypes.bool.isRequired,
};

export default GridTileInnerTypeImage;
